(() => {
  let cartInstance;
  const boundButtons = new WeakSet();
  const initializeCart = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.wvrReady || !window.theme?.CartDrawer || document.body.classList.contains('template-cart')) return;
    drawer.dataset.wvrReady = 'true';
    cartInstance = new window.theme.CartDrawer();
    document.querySelectorAll('.js-drawer-open-cart').forEach(button => boundButtons.add(button));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCart, { once: true });
  else initializeCart();
  document.addEventListener('shopify:section:load', event => {
    if (!cartInstance) return;
    event.target.querySelectorAll('.js-drawer-open-cart').forEach(button => {
      if (boundButtons.has(button)) return;
      boundButtons.add(button);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', cartInstance.drawer.open.bind(cartInstance.drawer));
    });
  });
})();
